import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';

import { addMarkerImagesToMap } from '@App/components/Map/map.utils';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

import SearchControl from './controls/SearchControl/SearchControl';
import KeyControl from './controls/KeyControl/KeyControl';
import NavigationControl from './controls/NavigationControl/NavigationControl';
import sources from './map.sources';
import layers from './map.layers';

import 'maplibre-gl/dist/maplibre-gl.css';
import './map.css';

function Map({ map, setMap }) {
  const { isLoggedIn } = useAuth();
  const mapRef = useRef(null);

  useEffect(() => {
    const maplibreMap = new maplibregl.Map({
      container: mapRef.current,
      style: `https://api.maptiler.com/maps/019b31ff-0cf1-7e45-a555-91e6992c2e6a/style.json?key=${import.meta.env.VITE_MAPTILER_KEY}`,
      preserveDrawingBuffer: true,
      center: [4.2, 51.1],
      zoom: 8,
      maxBounds: [
        [2.1016113281244486, 50.41019427107747],
        [6.29838867187425, 51.77966486336484],
      ],
    });

    maplibreMap.setMaxPitch(0);

    maplibreMap.addControl(new SearchControl(maplibreMap), 'top-left');
    maplibreMap.addControl(new NavigationControl(maplibreMap), 'top-right');

    maplibreMap.on('load', async () => {
      Object.keys(sources).forEach((sourceId) => {
        maplibreMap.addSource(sourceId, sources[sourceId]);
      });

      await addMarkerImagesToMap(maplibreMap);
      layers.forEach(layer => maplibreMap.addLayer(layer));
    });

    maplibreMap.once('load', () => {
      setMap(maplibreMap);
    });

    return () => maplibreMap.remove();
  }, [setMap]);

  useEffect(() => {
    const keyControl = new KeyControl(map);
    if (map && isLoggedIn) {
      map.addControl(keyControl, 'top-right');
    };
    return () => {
      if (map && keyControl) {
        map.removeControl(keyControl);
      }
    };
  }, [map, isLoggedIn]);

  return (
    <div ref={mapRef} className="map" />
  );
}

export default Map;
